import * as React from 'react'
import toast from 'react-hot-toast'

export function debounce(func, wait, immediate) {
  var timeout
  return function () {
    var context = this,
      args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export function toastMultilineErrors(messageArray) {
  toast.error(
    <ul className="m-0">
      {messageArray?.map((msg, i) => (
        <li className="list-disc" key={i}>
          {msg}
        </li>
      ))}
    </ul>
  )
}
